"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NavigationTreeEmptyMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faInfoCircle = require("@fortawesome/pro-regular-svg-icons/faInfoCircle");

var _faPlusCircle = require("@fortawesome/pro-regular-svg-icons/faPlusCircle");

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var NavigationTreeEmptyMessage = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n\n    p {\n        font-size: 1.1rem;\n    }\n"])));

exports.NavigationTreeEmptyMessage = NavigationTreeEmptyMessage;

var NavigationTreeEmpty = function NavigationTreeEmpty(_ref) {
  var setModalData = _ref.setModalData,
      setShowAddModal = _ref.setShowAddModal;
  return /*#__PURE__*/_react["default"].createElement(NavigationTreeEmptyMessage, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faInfoCircle.faInfoCircle,
    size: "6x",
    className: "mb-3"
  }), /*#__PURE__*/_react["default"].createElement("p", null, "No items have been added to this menu"), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary",
    onClick: function onClick() {
      setModalData({});
      setShowAddModal(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlusCircle.faPlusCircle,
    className: "mr-2"
  }), "Add Item"));
};

var _default = NavigationTreeEmpty;
exports["default"] = _default;